import { RegisterOptions } from 'react-hook-form';
import { RFC822_VALID_EMAIL_REGEX } from 'utils/validation';

export type Validation = {
    length: boolean;
    uppercase: boolean;
    lowercase: boolean;
    number: boolean;
    specialCharacter: boolean;
};

const minPasswordLength = 8;
const maxPasswordLength = 256; // This is Cognito's max password length

export const getPasswordRules = (previousPassword: string): RegisterOptions => ({
    validate: {
        containsLowerCase: (value) =>
            /[a-z]/.test(value) || ' Password must contain at least one lowercase letter',
        containsUpperCase: (value) =>
            /[A-Z]/.test(value) || 'Password must contain at least one uppercase letter',
        containsNumber: (value) =>
            /[0-9]/.test(value) || 'Password must contain a number',
        containsSpecialCharacter: (value) =>
            /[\^$*.[\]{}()?"!@#%&/\\,><':;|_~`]/.test(value) ||
            'Password must contain a special character',
        containsIdenticalMatch: (value) =>
            previousPassword !== value || 'Password can not be previous password',
    },
    maxLength: {
        value: maxPasswordLength,
        message: `Password cannot exceed ${maxPasswordLength} characters.`,
    },
    minLength: {
        value: minPasswordLength,
        message: `Password must exceed ${minPasswordLength} characters.`,
    },
});

// This matches Prometheus.Shared.PrometheusConstants.UserEmailMaxLength
export const userEmailMaxLength = 128;

export const sdUserEmailRules: RegisterOptions = {
    required: 'Please enter a valid email address.',
    maxLength: {
        value: userEmailMaxLength,
        message: 'Email is too long.',
    },
    pattern: {
        value: RFC822_VALID_EMAIL_REGEX,
        message: 'Please enter a valid email address.',
    },
};
